export const year = (state) => state.year
export const handoutFilters = (state) => state.handoutFilters
export const catalog = (state) => state.catalog
export const cmsTypes = (state) => state.cmsTypes
export const textBook = (state) => state.textBook
export const defaultbook = (state) => state.defaultbook
export const bkId = (state) => state.bkId
export const kps = (state) => state.kps
export const singleormulti = (state) => state.singleormulti
export const bookorkps = (state) => state.bookorkps
export const factors = (state) => state.factors
